import { FormEvent, useMemo, useState } from "react";
import { Layout } from "../components/Layout";
import { Panel } from "../components/Panel";
import { setupPurchasedAccount } from "../lib/api/publicBillingClient";
import { t, useWorkspaceLanguage, withLanguagePrefix } from "../lib/i18n";

export function SetupAccount() {
  const language = useWorkspaceLanguage();
  const labels = t(language).setupAccount;
  const token = useMemo(() => (
    typeof window === "undefined" ? "" : new URLSearchParams(window.location.search).get("token") ?? ""
  ), []);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState<string | undefined>();
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setMessage(undefined);
    if (!token) {
      setMessage(labels.missingToken);
      return;
    }
    if (password !== confirmPassword) {
      setMessage(labels.mismatch);
      return;
    }
    setIsSubmitting(true);
    const result = await setupPurchasedAccount(token, password, name);
    setIsSubmitting(false);
    if (!result.ok) {
      setMessage(result.message ?? labels.error);
      return;
    }
    setSuccess(true);
    setMessage(labels.readyBody);
  }

  return (
    <Layout
      title={labels.title}
      description={labels.description}
    >
      <Panel title={success ? labels.readyTitle : labels.panelTitle} variant="accent">
        {success ? (
          <div className="question-flow">
            <p>{message}</p>
            <a className="button button-primary" href={withLanguagePrefix("/workspace", language)}>
              {labels.openWorkspace}
            </a>
          </div>
        ) : (
          <form className="form" onSubmit={handleSubmit}>
            <label htmlFor="account-name">{labels.name}</label>
            <input id="account-name" value={name} onChange={(event) => setName(event.target.value)} autoComplete="name" />
            <label htmlFor="account-password">{labels.password}</label>
            <input
              id="account-password"
              type="password"
              minLength={12}
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <label htmlFor="account-confirm-password">{labels.confirmPassword}</label>
            <input
              id="account-confirm-password"
              type="password"
              minLength={12}
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              required
            />
            <p className="form-note">{labels.note}</p>
            {message ? <p className="form-error" role="alert">{message}</p> : null}
            <button className="button button-primary" type="submit" disabled={isSubmitting}>
              {labels.submit}
            </button>
          </form>
        )}
      </Panel>
    </Layout>
  );
}
